/**
 * The Health tab's features list (SF-5096): for each feature, whether the company has it
 * switched on and whether it used it in the month. Some features have no switch on the company;
 * those show "Not tracked" rather than a guess.
 */
import { Table, Tag } from 'antd';
import type { CompanyFeatureRow } from '../../../../components/usage/usageClient';
import { USAGE_TYPE_LABELS } from '../../../../components/usage/usageNumbers';

function switchedOnText(value: boolean | null): string {
  if (value === null) return 'Not tracked';
  return value ? 'Yes' : 'No';
}

export const CompanyFeaturesTable: React.FC<{ features: CompanyFeatureRow[] }> = ({ features }) => (
  <Table<CompanyFeatureRow>
    size="small"
    rowKey="type"
    pagination={false}
    dataSource={features}
    aria-label="Features"
    columns={[
      {
        title: 'Feature',
        key: 'type',
        render: (_, row) => USAGE_TYPE_LABELS[row.type] ?? row.type,
      },
      {
        title: 'Switched on',
        key: 'switched_on',
        render: (_, row) => switchedOnText(row.switched_on),
      },
      {
        title: 'Used this month',
        key: 'used',
        render: (_, row) =>
          row.used ? (
            'Yes'
          ) : row.switched_on === true ? (
            // The case staff look for: a feature the company has but does not use.
            <Tag color="warning">Switched on, not used</Tag>
          ) : (
            'No'
          ),
      },
    ]}
  />
);
